import Vodka from '../images/voldka.jpg';
import Airpuff from '../images/airpuff.png';
import Rigel from '../images/rigel-protocol.jpg';
import BidAuction from '../images/bida2.png';
import QUILLTEST from '../images/quill-test.jpg';
import DEXIRA from '../images/dexira.jpg';
import HALBORN from '../images/hallborn.jpg';
import PAYCREST from '../images/white-paycrest.png';

import {
   ReusableProjectContent,
   ReusableProjectContent1,
} from './ReusableProjectContent';

const ProjectContent = () => {
   //    useEffect(() => {
   //       axios
   //          .get('https://sideshift.ai/api/v2/pair/eth/usdc-bsc')
   //          .then((response) => {
   //             console.log(response.data);
   //          })
   //          .catch((error) => {
   //             console.log(error);
   //          });
   //    }, []);

   return (
      <>
         <div className="mx-auto max-w-5xl p-6 ">
            <h2 className="title">Projects</h2>
            <hr className="hr" />

            {/* PAYCREST */}
            <ReusableProjectContent
               title="PAYCREST"
               description="Paycrest is a blockchain-powered platform revolutionizing cross-border payments with seamless on-ramp and off-ramp exchanges. At Paycrest, I developed and maintained core protocol features, focusing on automated liquidity aggregation, scalable payment systems, and cross-chain interoperability. Integrating Golang with account abstraction Technologies: Solidity, Go, TypeScript, Docker, PostgreSQL, Redis, LibP2P."
               imageUrl={PAYCREST}
               linkUrl="https://www.paycrest.io/"
            />
            {/* VAULTKA */}

            <ReusableProjectContent1
               title="VAULTKA"
               description="Vaultka is a DeFi protocol specializing in the Decentralized Perpetual Exchange (Perp DEX) market. The platform is designed to optimize liquidity provider (LP) returns and offer diversified investment opportunities through innovative financial products. It incorporates advanced features such as auto-hedging and portfolio rebalancing, enabling effective risk management and optimized returns for liquidity providers. Integrating with protocols like GMX, HMX, Compound, VELA, KTX Finance, Kyber, Uniswap, Compound. Technologies: Solidity, Hardhat, OpenZeppelin, Foundry, TypeScript."
               imageUrl={Vodka}
               linkUrl="https://www.vaultka.com/app/vaults"
            />

            {/* AIRPUFF */}
            <ReusableProjectContent
               title="AIRPUFF"
               description="AirPuff is an advanced DeFi platform within the Airdropfi ecosystem, designed to maximize airdrop rewards for users through innovative strategies and algorithms. The platform targets diverse markets, including restaking, liquid restaking, stablecoins, non-EVM ecosystems like Solana, and Layer 1 and Layer 2 blockchains, offering users enhanced opportunities for airdrop farming and optimized returns. Borrowers benefit from a dynamic interest rate model, where rates vary with the utilization of lending pools. Integrating with protocols like EigenLayer, pendle principal tokens, Renzo, Bedrock, Vector. Technologies: Solidity, Hardhat, OpenZeppelin, Foundry, TypeScript."
               imageUrl={Airpuff}
               linkUrl="https://airpuff.io/"
            />

            {/* RIGEL PROTOCOL */}
            <ReusableProjectContent
               title="RIGEL PROTOCOL"
               description="Rigel Protocol is a blockchain-based ecosystem offering innovative solutions like Decentralized P2P system, launchpads, NFT marketplaces, and DeFi tools for the Web3 space. At Rigel, I architected and developed smart contracts for the Decentralized P2P system, launchpad, NFT marketplace, and gifting dApp, while mentoring junior engineers on best practices and security standards. Technologies: Solidity, Hardhat, OpenZeppelin, Foundry, TypeScript, Slither, Echidna, Golang."
               imageUrl={Rigel}
               linkUrl="https://www.rigelprotocol.com"
            />

            {/* BID AUCTION */}

            {/* HALBORN CTF */}
            <ReusableProjectContent1
               title="HALBORN CTF"
               description="   Halborn CTF is a lending pool smart contract. I evaluated
                     10 security properties across 2 main contracts. In the
                     process, I formalized and tested a variety of properties,
                     from high-level ones to very specific. Regarding property
                     coverage, the core of the contract, consisting of the loan
                     and nft contract, received substantial coverage."
               imageUrl={HALBORN}
               linkUrl="https://github.com/OnahProsper/audits/blob/main/Halborn-ctf-security-audit.pdf"
            />

            {/* // DEXIRA SMART CONTRACT */}
            <ReusableProjectContent
               title="DEXIRA SMART CONTRACT"
               description="Dexira is a token contract private audit. Technologies: Solidity, OpenZeppelin, Foundry, TypeScript, Slither, Echidna."
               imageUrl={DEXIRA}
               linkUrl="https://github.com/OnahProsper/audits/blob/main/DEXIRA2%20SMART%20CONTRACT%20SECURITY%20AUDIT%20wordfinal.pdf"
            />

            {/* // QUILL TEST
            <ReusableProjectContent1
               title="QUILL SECURITY TEST"
               description=" I evaluated 16 security properties across 2 main contracts.
                     In the process, I formalized and tested a variety of
                     properties, from high-level ones to very specific and
                     low-level ones in basic libraries like SafeMath.sol and
                     Address.sol Regarding property coverage, the core of the
                     contract, consisting of the token contract and its
                     libraries, received substantial coverage. The token contract contains the main business logic. It is
                     the entry point for essential operations such as transfers,
                     approvals, and staking platform. I identified security
                     properties for each contract used to implement the token
                     contract. Each property listed is valid regardless of the
                     state, initialized or not, of the Exchange contract."
               imageUrl={QUILLTEST}
               linkUrl="https://github.com/OnahProsperity/audits/blob/main/quill-security-audit.pdf"
            /> */}

            <ReusableProjectContent1
               title="BID AUCTION"
               description=" Bid auction private audit for a token vesting contract. Technologies: Solidity, OpenZeppelin, Foundry, TypeScript, Slither, Echidna."
               imageUrl={BidAuction}
               linkUrl="https://github.com/OnahProsper/audits/blob/main/bid-auction-security-audit.pdf"
            />
         </div>
      </>
   );
};

export default ProjectContent;
